import { makeStyles } from '../../styles';

export const useMarksStyles = makeStyles([
  [
    'marks',
    (_, [vertical, handlerSize]) => [
      `
		position: absolute;
		font-size: 14px;
	`,
      !vertical &&
        `
			top: ${handlerSize * 1.25}px;
			left: 0;
			width: 100%;
		`,
      vertical &&
        `
			top: 0;
			left: ${handlerSize * 1.25}px;
			width: ${handlerSize}px;
			height: 100%;
		`
    ]
  ],
  [
    'mark',
    theme => `
		display: inline-block;
		position: absolute;
		color: ${theme.color.text.B3};
		text-align: center;
		word-break: keep-all;
		cursor: pointer;
		user-select: none;
	`
  ]
]);
